import { ServerSettings } from '../serverSettings';
import { ServiceException } from './serviceException';
import { ValidationMessage } from './validationMessage';

type HttpMethods = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface FileUploadModel {
    file: File;
    id: number;
    fileUploadSessionId: string;
    autoMarkDelete?: boolean;
}

export class HttpClient {
    private readonly baseUrl: string;

    constructor(serverSettings: ServerSettings) {
        this.baseUrl = serverSettings.baseUrl;
    }

    public get<T>(route: string, data?: any): Promise<T> {
        return this.call<T>('GET', route, data);
    }

    public post<T>(route: string, data?: any): Promise<T> {
        return this.call<T>('POST', route, data);
    }

    public put<T>(route: string, data?: any): Promise<T> {
        return this.call<T>('PUT', route, data);
    }

    public delete<T>(route: string, data?: any): Promise<T> {
        return this.call<T>('DELETE', route, data);
    }

    private call<T>(method: HttpMethods, route: string, data?: any): Promise<T> {
        const uri = this.combine(this.baseUrl, route);
        const settings = this.getAjaxSettings(method, uri, data);
        settings.contentType = 'application/json';
        return new Promise((resolve, reject) => {
            settings.success = resolve;
            settings.error = this.handleError(reject, uri);
            $.ajax(settings);
        });
    }

    private getAjaxSettings(method: HttpMethods, uri: string, data?: any): JQueryAjaxSettings {
        let processedData = data;
        if (data !== undefined && method !== 'GET') {
            processedData = JSON.stringify(data);
        }
        const settings: JQueryAjaxSettings = {
            // dataType: 'json',
            method: method,
            url: uri,
            data: processedData,
            accepts: { json: 'application/json' },
        };
        return settings;
    }

    private handleError = (reject, uri: string) => {
        return (xhr?: any): void => {
            if (xhr.status === 400 && xhr.responseJSON && Array.isArray(xhr.responseJSON)) {
                reject(new ServiceException(true, this.mapValidationMessages(xhr.responseJSON)));
                return;
            } else if (xhr.status === 401) {
                reject(this.unauthorizedMessage());
                return;
            } else if (xhr.status === 404) {
                reject(this.notFoundsMessage(uri));
            }
            reject(xhr);
        }
    };

    private mapValidationMessages(serverValidationMessages: any[]) {
        if (!serverValidationMessages) {
            return [];
        }
        return serverValidationMessages.map(msg => new ValidationMessage(msg.code, msg.message));
    }

    private unauthorizedMessage() {
        return new ServiceException(true, [new ValidationMessage('UNAUTHORIZED', 'You are not authorized to perform that action')]);
    }

    private notFoundsMessage(uri: string) {
        return new ServiceException(false, [new ValidationMessage('NOTFOUND', `The url requested returned a 404: ${uri}`)]);
    }

    private combine(baseUrl: string, route: string) {
        let url = baseUrl;
        if (baseUrl.endsWith('/')) {
            url = url.substr(0, url.length - 1);
        }
        let modifiedRoute = route;
        if (route.startsWith('/')) {
            modifiedRoute = route.substr(1, route.length);
        }
        return `${url}/${modifiedRoute}`;
    }
}